import { render, staticRenderFns } from "./ruleConfiguration.vue?vue&type=template&id=1cf25ceb&scoped=true"
import script from "./ruleConfiguration.vue?vue&type=script&lang=js"
export * from "./ruleConfiguration.vue?vue&type=script&lang=js"
import style0 from "./ruleConfiguration.vue?vue&type=style&index=0&id=1cf25ceb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf25ceb",
  null
  
)

export default component.exports